// const mxModule = require("mxgraph")();
// const {
//     mxCylinder, mxPoint, mxConnectionConstraint
//   } = mxModule;
import { mxCylinder } from "../utils/graph/mxModule";
function pmosShape() { }
    pmosShape.prototype = new mxCylinder();
    pmosShape.prototype.constructor = pmosShape;

    // Connections are handled by child port ellipses (G, D, S) inserted at placement time
    pmosShape.config = {
      width: 60,
      height: 90,
      ports: [
        { name: "G", label: "", x: 0, y: 0.5 },
        { name: "S", label: "", x: 1, y: 0   },
        { name: "D", label: "", x: 1, y: 1   },
      ],
    };

    pmosShape.prototype.paintVertexShape = function (c, x, y, w, h) {
      const dx = w / 60;
      const dy = h / 90;
    
      const px = v => v * dx;
      const py = v => v * dy;
    
      // === 1. Transparent bounding rect (hit area only) ===
      c.setFillColor('none');
      c.setStrokeColor('none');
      c.rect(x, y, w, h);
      c.fillAndStroke();
    
      // === 2. Styled visible path ===
      c.setStrokeColor(this.stroke || '#000000'); // default stroke
      c.setStrokeWidth(1/this.scale);
      c.setFillColor('none'); // no fill
    
      // drain line
      c.begin();
      c.moveTo(x + px(60), y + py(0));
      c.lineTo(x + px(60), y + py(26));
    
      // top horizontal
      c.moveTo(x + px(28), y + py(26));
      c.lineTo(x + px(60), y + py(26));
    
      // left vertical
      c.moveTo(x + px(28), y + py(26));
      c.lineTo(x + px(28), y + py(64));
    
      // bottom horizontal
      c.moveTo(x + px(28), y + py(64));
      c.lineTo(x + px(60), y + py(64));
    
      // right diagonal up
      c.moveTo(x + px(50), y + py(26));
      c.lineTo(x + px(58), y + py(22));
    
      // right diagonal down
      c.moveTo(x + px(50), y + py(26));
      c.lineTo(x + px(58), y + py(30));
    
      // source line
      c.moveTo(x + px(60), y + py(90));
      c.lineTo(x + px(60), y + py(64));
        
      // left support
      c.moveTo(x + px(24), y + py(26));
      c.lineTo(x + px(24), y + py(64));
    
      // gate
      c.moveTo(x + px(0), y + py(45));
      c.lineTo(x + px(24), y + py(45));
    
      c.stroke();
    };

    export default pmosShape